import { Dialog, DialogModule, DialogRef } from '@angular/cdk/dialog';
import { ChangeDetectionStrategy, Component, Injector, OnDestroy, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { pathParameter } from '@libs/shared-services';
import { toSignal } from '@angular/core/rxjs-interop';
import { routes } from '@libs/utils';
import { NotesScreenService } from '@libs/notes';
import { ToothDetailsDialogComponent } from '../tooth-details-dialog/tooth-details-dialog.component';
import { ToothDetailsDialogData } from '../tooth-details-dialog/tooth-details-dialog.vm';

@Component({
  selector: 'ffd-tooth-details-dialog-container',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, DialogModule],
})
export class ToothDetailsDialogContainerComponent implements OnInit, OnDestroy {
  private readonly dialog = inject(Dialog);
  private dialogRef: DialogRef<ToothDetailsDialogComponent> | null = null;
  private readonly injector = inject(Injector);

  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly params = toSignal(this.activatedRoute.paramMap);
  private readonly router = inject(Router);
  private readonly notesService = inject(NotesScreenService);

  public ngOnInit(): void {
    const siteId = this.params()!.get(pathParameter('siteId')) ?? undefined;
    const patientId = this.params()!.get(pathParameter('patientId')) ?? undefined;
    const toothPosition = Number(this.params()!.get(pathParameter('toothPosition')));

    this.notesService.init();
    if (!siteId || !patientId || Number.isNaN(toothPosition)) {
      this.router.navigate([routes.charting, siteId, routes.patients, patientId]);
    }

    this.dialogRef = this.dialog.open<ToothDetailsDialogComponent, ToothDetailsDialogData>(ToothDetailsDialogComponent, {
      backdropClass: ['backdrop-blur-overlay', 'bg-overlay-light', 'tooth-details-modal-backdrop'],
      disableClose: true,
      data: {
        screen: 'charting',
        toothPosition,
        siteId,
        patientId,
      },
      autoFocus: '__non_existing_element__',
      injector: this.injector,
    });
  }

  public ngOnDestroy(): void {
    this.dialogRef?.close();
  }
}
